module.exports = __webpack_public_path__ + "static/media/Emer-bannerweb-4.7b278bb8.png";